// Auto-generated from proto definitions. DO NOT EDIT.

export type AutoUnsealProvider = 'AUTO_UNSEAL_PROVIDER_UNSPECIFIED' | 'AUTO_UNSEAL_PROVIDER_AWS_KMS' | 'AUTO_UNSEAL_PROVIDER_GCP_KMS' | 'AUTO_UNSEAL_PROVIDER_AZURE_KEY_VAULT' | 'AUTO_UNSEAL_PROVIDER_YANDEX_KMS' | 'AUTO_UNSEAL_PROVIDER_TRANSIT';

export const AutoUnsealProviderValues = ['AUTO_UNSEAL_PROVIDER_UNSPECIFIED', 'AUTO_UNSEAL_PROVIDER_AWS_KMS', 'AUTO_UNSEAL_PROVIDER_GCP_KMS', 'AUTO_UNSEAL_PROVIDER_AZURE_KEY_VAULT', 'AUTO_UNSEAL_PROVIDER_YANDEX_KMS', 'AUTO_UNSEAL_PROVIDER_TRANSIT'] as const;
